import React, { useEffect, useState } from 'react'
import ImageRenderer from '../../../../pages/sharepost/ImageRenderer';
import { AiOutlineClose } from 'react-icons/ai';
import { CiMusicNote1 } from "react-icons/ci";
import { IoIosMore } from "react-icons/io";
import { BsStars } from "react-icons/bs";
import { ReactComponent as Sticker } from './Sticker.svg';
import './SelectSticker.css';

export default function selectSticker({ details, template, index }) {
    const [CTA, setCTA] = useState();
    const [imageUrl, setImageUrl] = useState({});
    const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

useEffect(() => {
    if(details.giveorreceive === "give"){
        setCTA("Let me make your day. Accept anonymously.");
    } else if (details.giveorreceive === "receive"){
        setCTA("Make my day, anonymously.");
    }
    if(details.type === "item"){
        setImageUrl({
            [details.title]: details.photo,
        });
    }
}, [details])

return (
<div className="insta-sticker-container">
        <div className="image-renderer-wrapper">
            <ImageRenderer
                key={`${template}-${index}-${2}`}
                details={details}
                cta={CTA}
                templateIndex={index}
                scale={2}
                imageUrls={imageUrl}
            />
                <div className="icons-overlay">
                    <div className="exit-icon-container">
                        <AiOutlineClose className="icon"></AiOutlineClose>
                    </div>
                    <div className="left-icons-container">
                        <p className='icon' style={{ fontFamily: "Arial" }}>Aa</p>
                        <div className="sticker-icon-container">
                                <Sticker className="icon"></Sticker>
                                <img className="circle-gif" src={`${cloudfrontUrl}/static/circle.gif`}></img>
                        </div>
                        <CiMusicNote1 className='icon'></CiMusicNote1>
                        <BsStars className='icon'></BsStars>
                        <IoIosMore className='icon'></IoIosMore>
                    </div>
            </div>
        </div>
    </div>
  )
}
